<template>
    <div class="avatar-container" :class="{ 'avatar-container--small': small }">
        <img v-if="src" :src="src" :alt="alt" class="avatar-container__image" />
        <div v-else class="text-[#c59014]">
            {{ label }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'AvatarContainer',
    props: {
        src: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            default: 'User Avatar'
        },
        small: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    }
}
</script>

